import script from "./MateEmpty.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MateEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./MateEmpty.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MateEmpty.vue?vue&type=script&setup=true&lang=ts"

import "./MateEmpty.vue.scss?vue&type=style&index=0&id=8ae48ccc&lang=scss!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MateEmpty.vue?vue&type=style&index=0&id=8ae48ccc&lang=scss"

const __exports__ = script;

export default __exports__